var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import classNames from "classnames";
import Icon from "../Icon/Icon";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";

import styles from "./AuthDrawer.css";

var ForgotPasswordFour = function (_Component) {
  _inherits(ForgotPasswordFour, _Component);

  function ForgotPasswordFour() {
    _classCallCheck(this, ForgotPasswordFour);

    return _possibleConstructorReturn(this, (ForgotPasswordFour.__proto__ || Object.getPrototypeOf(ForgotPasswordFour)).apply(this, arguments));
  }

  _createClass(ForgotPasswordFour, [{
    key: "changeStep",
    value: function changeStep(step) {
      this.props.authDrawerActions.changeStep(step);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: styles.container },
        React.createElement(
          "div",
          { className: styles.textCenter },
          React.createElement(Icon, { className: styles.checkmark, name: "check/rounded" })
        ),
        React.createElement(
          "div",
          { className: styles.marginTop20 },
          "We have updated your password. You can now log in."
        ),
        React.createElement(
          "div",
          { className: classNames(styles.nextButton, styles.marginTop20) },
          React.createElement(
            "button",
            { onClick: this.changeStep.bind(this, authDrawerConstants.SIGNIN), className: classNames(styles.blueButton1, styles.block, styles.centered) },
            "Sign In"
          )
        )
      );
    }
  }]);

  return ForgotPasswordFour;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordFour);


// WEBPACK FOOTER //
// ./src/components/Library/AuthDrawer/ForgotPasswordFour.js